'use client'
import React from 'react'
import { GlobalErrorView } from '@/components/global-error-view'

export default function GlobalErrorPage({ error, reset }: { error: Error; reset: () => void }) {
  console.error(error)

  return (
    <html lang="en-GB">
      <body>
        <GlobalErrorView reset={reset} debugKey="global-error" debugData={error} />
      </body>
    </html>
  )
}
